module.exports = __webpack_public_path__ + "e8688062e43dbd51e6458acefd84d15f.svg";